// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Oqbs","colMin":"styles_colMin__3Jbxz"};